import React, { Fragment, useState, useEffect } from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Row, Button } from 'reactstrap';
import ModalUI from '../../../shared/components/Modal';

const AttetionAdmission = ({ }) => {
    const [templeteAttentionAdmission, setTempleteAttentionAdmission] = useState(null);
    const [alreadyCreated, setAlreadyCreated] = useState(false);
    const [idTemplate, setidTemplate] = useState(null);
    const [errors, setErrors] = useState({})

    const [openAlert, setOpenAlert] = useState(false);
    const [modalAlert, setModalAlert] = useState({ message: '', color: '', title: '' });

    useEffect(() => {
        loadCertTemplete();
    }, [])
    
    const loadCertTemplete = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'pantillas-cert-admision/listar', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                console.log('dataPlantilla', data);

                if (data !== undefined && data !== null) {
                    if (data.length > 0) {
                        setAlreadyCreated(true);
                        setTempleteAttentionAdmission(data[0].plantilla_certificado_admision);
                        setidTemplate(data[0].id_certificado_admision_plantilla)
                    } else {
                        setAlreadyCreated(false);
                    }
                }
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    const validateForm = (values) => {
        const errors = {};
        if (!values.plantilla_certificado_admision) {
            errors.nombre = "El Campo es obligatorio";
        }
        console.log("ERRORSFORM", errors);
        return errors;
    }

    const saveTempleteCertAdmission = () => {
        let dataSend = {
            plantilla_certificado_admision: templeteAttentionAdmission
        };

        let errors = validateForm(dataSend);
        setErrors(errors);

        if (Object.entries(errors).length === 0) {
            fetch(process.env.REACT_APP_PUBLIC_URL + 'pantillas-cert-admision/create', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(dataSend)
            })
                .then(response => {
                    if (response.status != 500 && response.status != 403) {
                        return response.json();
                    }
                    else {
                        throw new Error(response.json());
                    }
                })
                .then(data => {
                    console.log(data);
                    setOpenAlert(true);
                    loadCertTemplete();
                    setModalAlert({
                        message: "Formato creado con exito",
                        color: 'success',
                        title: "Exitoso!"
                    });
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        }
    }

    const updateTempleteCertAdmission = () => {
        let dataSend = {
            id_certificado_admision_plantilla: idTemplate,
            plantilla_certificado_admision: templeteAttentionAdmission
        };

        let errors = validateForm(dataSend);
        setErrors(errors);

        if (Object.entries(errors).length === 0) {
            fetch(process.env.REACT_APP_PUBLIC_URL + 'pantillas-cert-admision/update', {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(dataSend)
            })
                .then(response => {
                    if (response.status != 500 && response.status != 403) {
                        return response.json();
                    }
                    else {
                        throw new Error(response.json());
                    }
                })
                .then(data => {
                    console.log(data);
                    setOpenAlert(true);
                    setModalAlert({
                        message: "Formato actualizado con exito",
                        color: 'success',
                        title: "Exitoso!"
                    });
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        }
    }
    return (
        <Fragment>
            <Row>
                <div className="card__title">
                    <h5 className="bold-text">Formato de Certificado de Admisión</h5>
                </div>
            </Row>
            <Row>
                <div>
                    <p>
                        <b>Variables: </b>
                        Puede Utilizar las siguientes variables para ser reemplazadas en el Texto de manera Automatica, para utilziarlas, en la Plantilla debe escribir entre llaves la variable que desea utilizar
                    </p>
                    <ul>
                        <li>
                            {'{paciente}:'} Paciente que es atendido en la Cita Médica
                        </li>
                        <li>
                            {'{procedimiento}:'} Consulta o Procedimiento que se le realiza al Paciente (Ejemplo, Gamagrafia, Consulta General)
                        </li>
                        <li>
                            {'{tipo_identidad}:'} Tipo de Documento del Paciente
                        </li>
                        <li>
                            {'{identidad}:'} Tipo y Número de Documento del Paciente
                        </li>
                        <li>
                            {'{empresa}:'} IPS o Empresa
                        </li>
                        <li>
                            {'{profesional}:'} Profesional en salud encargado del Procedimiento o Consulta
                        </li>
                        <li>
                            {'{direccion}:'} Dirección de la IPS
                        </li>
                    </ul>
                </div>
            </Row>
            <Row>
                <div style={{ margin: 10 }}>
                    {<CKEditor
                        style={{ width: '100%', height: '200px' }}
                        editor={ClassicEditor}
                        data={templeteAttentionAdmission !== null ? templeteAttentionAdmission : null}
                        onChange={(event, editor) => {
                            const data = editor.getData();
                            setTempleteAttentionAdmission(data);
                        }}
                    />}
                </div>
            </Row>
            <Row>
                <div className= 'flex-end-elem'>
                    <div>
                <Button
                    color="primary"
                    size='sm'
                    onClick={() => {
                        if (alreadyCreated) {
                            updateTempleteCertAdmission();
                        }
                        else {
                            saveTempleteCertAdmission();
                        }
                    }}
                >
                    {alreadyCreated ? 'Actualizar' : 'Guardar'}
                </Button>
                    </div>
                </div>
            </Row>
            {openAlert ?
                <ModalUI
                    color={modalAlert.color}
                    title={modalAlert.title}
                    message={modalAlert.message}
                    modal={openAlert}
                    toggle={() => { setOpenAlert(!openAlert) }}
                    onOk={() => { setOpenAlert(!openAlert) }}
                /> : null}
        </Fragment>
    )
}
export default AttetionAdmission